(function () {
  'use strict';

  function findModelSelect(root) {
    var selects = root.querySelectorAll('select');
    var direct = root.querySelector('select[aria-label*="Compatibility"], select[name*="Compatibility"], select[id*="Compatibility"], select[name*="Model"], select[id*="Model"]');
    if (direct) return direct;
    for (var i = 0; i < selects.length; i += 1) {
      var select = selects[i];
      var text = [select.name, select.id, select.getAttribute('aria-label')].filter(Boolean).join(' ');
      var label = select.id ? document.querySelector('label[for="' + CSS.escape(select.id) + '"]') : null;
      if (label) text += ' ' + label.textContent;
      if (/compatibility|iphone model|model/i.test(text)) return select;
    }
    return selects.length === 1 ? selects[0] : null;
  }

  function createMobileSticky(root, addButton, model) {
    if (!addButton || document.querySelector('[data-tvx-mobile-atc]')) return;

    var bar = document.createElement('aside');
    bar.className = 'tvx-mobile-atc';
    bar.setAttribute('data-tvx-mobile-atc', '');
    bar.setAttribute('aria-label', 'Quick add to bag');
    bar.innerHTML = '<div class="tvx-mobile-atc__meta"><small data-tvx-mobile-atc-model>Choose your iPhone model</small><strong data-tvx-mobile-atc-price></strong></div><button type="button" data-tvx-mobile-atc-button>Choose model</button>';
    document.body.appendChild(bar);

    var stickyButton = bar.querySelector('[data-tvx-mobile-atc-button]');
    var modelText = bar.querySelector('[data-tvx-mobile-atc-model]');
    var priceText = bar.querySelector('[data-tvx-mobile-atc-price]');
    var priceNode = root.querySelector('.f8pr-price, .price, [data-product-price]');

    function sync() {
      var selected = model && model.value ? model.options[model.selectedIndex] : null;
      var disabled = Boolean(addButton.disabled || addButton.getAttribute('aria-disabled') === 'true' || !selected);
      stickyButton.disabled = disabled;
      stickyButton.textContent = disabled ? 'Choose model' : 'Add to bag';
      modelText.textContent = selected ? selected.textContent.trim() : 'Choose your iPhone model';
      if (priceNode) priceText.textContent = priceNode.textContent.replace(/\s+/g, ' ').trim();
    }

    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) {
        if (model) {
          model.focus({ preventScroll: true });
          model.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        }
        return;
      }
      addButton.click();
    });

    if (model) model.addEventListener('change', function () { window.setTimeout(sync, 0); });
    new MutationObserver(sync).observe(addButton, { attributes: true, childList: true, subtree: true });
    if (priceNode) new MutationObserver(sync).observe(priceNode, { childList: true, characterData: true, subtree: true });

    var visible = false;
    function setVisible(value) {
      visible = value && window.scrollY > 360;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { setVisible(!entry.isIntersecting); });
      }, { threshold: 0.15 });
      observer.observe(addButton);
      window.addEventListener('scroll', function () {
        if (window.scrollY <= 360 && visible) setVisible(false);
      }, { passive: true });
    } else {
      window.addEventListener('scroll', function () {
        var rect = addButton.getBoundingClientRect();
        setVisible(rect.bottom < 0 || rect.top > window.innerHeight);
      }, { passive: true });
    }

    sync();
  }

  function productPage() {
    if (!document.body.classList.contains('template-product')) return;
    var root = document.querySelector('.main-product') || document.querySelector('#main-product');
    if (!root) return;

    var model = findModelSelect(root);
    var addButton = root.querySelector('button.overlay-buy_button, button[name="add"], form[action*="/cart/add"] button[type="submit"]');
    var submit = addButton && addButton.closest('.submit');
    var title = Array.prototype.find.call(root.querySelectorAll('h1,h2,h3'), function (heading) {
      return /case/i.test(heading.textContent || '') && !/description/i.test(heading.textContent || '');
    });

    if (title) title.classList.add('tovynx-product-title');
    if (submit) submit.classList.add('tovynx-submit');
    if (addButton) addButton.classList.add('tovynx-add-button');

    if (!model || !addButton) return;

    if (root.dataset.tovynxModelGate !== 'true') {
      root.dataset.tovynxModelGate = 'true';
      var placeholder = Array.prototype.find.call(model.options, function (option) { return option.value === '' && /choose/i.test(option.textContent || ''); });
      if (!placeholder) {
        placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Choose your iPhone model';
        placeholder.disabled = true;
        model.insertBefore(placeholder, model.firstChild);
      }
      model.value = '';
      placeholder.selected = true;
      addButton.disabled = true;
      addButton.setAttribute('aria-disabled', 'true');
      addButton.dataset.originalLabel = addButton.dataset.originalLabel || addButton.textContent.trim() || 'Add to cart';
      addButton.textContent = 'Choose your iPhone model';

      var note = root.querySelector('.tovynx-model-gate');
      if (!note) {
        note = document.createElement('p');
        note.className = 'tovynx-model-gate';
        note.setAttribute('role', 'status');
        model.insertAdjacentElement('afterend', note);
      }
      note.textContent = 'Select the exact model that matches your iPhone.';

      model.addEventListener('change', function () {
        if (!model.value) return;
        addButton.disabled = false;
        addButton.removeAttribute('aria-disabled');
        addButton.textContent = addButton.dataset.originalLabel;
        note.textContent = model.options[model.selectedIndex].text + ' selected — ready to add to your bag.';
        note.classList.add('is-ready');
      });
    }

    createMobileSticky(root, addButton, model);
  }

  function cartPage() {
    if (!document.body.classList.contains('template-cart')) return;
    var main = document.querySelector('main') || document.body;
    var headings = main.querySelectorAll('h1,h2,h3');
    Array.prototype.forEach.call(headings, function (heading) {
      var text = (heading.textContent || '').trim();
      if (text === 'Cart') heading.textContent = 'Your bag';
      if (/We are looking[\s\S]*cart is empty/i.test(text)) heading.textContent = 'Your bag is empty.';
    });
    var benefit = document.createElement('div');
    benefit.className = 'tovynx-cart-benefits';
    benefit.innerHTML = '<strong>Secure checkout</strong><span>Exact model selection · Free standard shipping · Easy returns</span>';
    var checkout = main.querySelector('[name="checkout"], button.overlay-dynamic_buy_button');
    if (checkout && !main.querySelector('.tovynx-cart-benefits')) checkout.insertAdjacentElement('afterend', benefit);
  }

  function collectionPage() {
    if (!document.body.classList.contains('template-collection')) return;
    var params = new URLSearchParams(window.location.search);
    var model = params.get('filter.p.m.custom.compatible_iphone_models');
    if (!model) return;
    var hero = document.querySelector('.tovynx-collection-hero');
    if (!hero) return;
    var title = hero.querySelector('h1,h2');
    if (title) title.textContent = model + ' Cases';
    var count = document.querySelector('[data-product-count], .product-count, .collection-count');
    if (count) count.setAttribute('aria-label', 'Products matching ' + model);
  }

  function init() {
    productPage();
    cartPage();
    collectionPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());
